import axios from "axios";

export async function Summary(username, token) {
  return axios.get(process.env.REACT_APP_API_URI + "/tenants/summary", {
    headers: {
      Authorization: username + ":" + token,
    },
  });
}

export async function Tenant(username, token) {
  return axios.get(process.env.REACT_APP_API_URI + "/tenants/tenant", {
    headers: {
      Authorization: username + ":" + token,
    },
  });
}

export async function SaveTenant(
  username,
  token,
  microsoft_tenant_id,
  microsoft_client_id,
  microsoft_client_secret
) {
  return axios.post(
    process.env.REACT_APP_API_URI + "/tenants/save",
    {
      microsoft_tenant_id: microsoft_tenant_id,
      microsoft_client_id: microsoft_client_id,
      microsoft_client_secret: microsoft_client_secret,
    },
    {
      headers: {
        Authorization: username + ":" + token,
      },
    }
  );
}

export async function ClientSecretExpiration(username, token) {
  return axios.get(
    process.env.REACT_APP_API_URI + "/tenants/client-secret-expiration/get",
    {
      headers: {
        Authorization: username + ":" + token,
      },
    }
  );
}

export async function SaveClientSecretExpiration(
  username,
  token,
  client_secret_expiration
) {
  return axios.post(
    process.env.REACT_APP_API_URI + "/tenants/client-secret-expiration/set",
    {
      client_secret_expiration: client_secret_expiration,
    },
    {
      headers: {
        Authorization: username + ":" + token,
      },
    }
  );
}

// Verifica del servizio Teams.
// Balanced: nessun payload. Direct: indirizzo Microsoft abilitato a Teams.
export async function CheckTeams(username, token, room_email) {
  return axios.post(
    process.env.REACT_APP_API_URI + "/tenants/check-teams",
    room_email ? { room_email: room_email } : {},
    {
      headers: {
        Authorization: username + ":" + token,
      },
    }
  );
}

export async function Balanced(username, token) {
  return axios.get(process.env.REACT_APP_API_URI + "/tenants/balanced-rooms", {
    headers: {
      Authorization: username + ":" + token,
    },
  });
}

export async function SaveBalanced(username, token, rooms) {
  return axios.post(
    process.env.REACT_APP_API_URI + "/tenants/balanced-rooms",
    {
      rooms: rooms,
    },
    {
      headers: {
        Authorization: username + ":" + token,
      },
    }
  );
}
